import React, { Component } from 'react';
import { Modal } from 'reactstrap';

class FormCreate extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        const { formValues } = this.props;
        const isError = !this.props.errorValues;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className="modal-dialog-centered rk-modal" backdrop={this.props.backdrop}>
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-project-diagram"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="rk-modal__body">
                        <div className="row">

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Nombre</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formValues.name}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.name == "" ? "rk-input--error" : ""}`}
                                        placeholder="Nombre"
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Tipo</label>
                                    <select
                                        name="proceso_type"
                                        value={formValues.proceso_type}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.proceso_type == "" ? "rk-input--error" : ""}`}
                                    >
                                        <option value="">Tipo de proceso</option>
                                        {this.props.tenant.app_type == "Salud" ? (
                                            <React.Fragment>
                                                <option value="procesos administrativos">Administrativo</option>
                                                <option value="procesos clinicos">Clínico</option>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <option value="Administrativo">Administrativo</option>
                                                <option value="Operativo">Operativo</option>
                                                <option value="Apoyo">Apoyo</option>
                                                <option value="Gestión">Gestión</option>
                                            </React.Fragment>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Prefijo</label>
                                    <input
                                        type="text"
                                        name="prefix"
                                        value={formValues.prefix}
                                        onChange={this.props.onChangeForm}
                                        className={`rk-input ${isError && formValues.prefix == "" ? "rk-input--error" : ""}`}
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Descripción <small className="validate-label">(opcional)</small></label>
                                    <textarea
                                        name="description"
                                        value={formValues.description}
                                        onChange={this.props.onChangeForm}
                                        className="rk-textarea"
                                        rows="6"
                                    />
                                </div>
                            </div>

                            {isError && (
                                <div className="col-md-12">
                                    <div className="rk-alert">
                                        <i className="fas fa-exclamation-circle"></i>
                                        Debes completar todos los campos requeridos
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>Cerrar</button>
                        <button
                            type="button"
                            className="rk-btn rk-btn--primary"
                            onClick={this.props.submitForm}
                            disabled={this.props.isLoaded}
                        >
                            {this.props.isLoaded ? <><i className="fas fa-spinner fa-spin"></i> Guardando…</>
                                : <><i className="fas fa-check"></i> {this.props.nameSubmit}</>}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default FormCreate;
